import React from "react";

import MessageBubble from "./MessageBubble";

export default function ConversationMessages({
    messages = [],
    currentUser,
    onDownloadFile

}) {

    //------------------------------------------------------
    // Aucun message
    //------------------------------------------------------

    if (!messages || messages.length === 0) {

        return (

            <div className="text-center py-5 text-muted">

                <i
                    className="bi bi-chat-square-text display-3"
                ></i>

                <h5 className="mt-3">

                    Aucun message

                </h5>

                <p>

                    Soyez le premier à écrire dans cette conversation.

                </p>

            </div>

        );

    }

    //------------------------------------------------------

    return (

        <div
            className="conversation-messages p-4"
            style={{
                maxHeight: "650px",
                overflowY: "auto",
                background: "#f8f9fa"
            }}
        >

            {

                messages

                    .sort((a, b) =>
                        new Date(a.dateMessage) -
                        new Date(b.dateMessage)
                    )

                    .map((message) => (

                        <MessageBubble

                            key={message.id}

                            message={message}

                            currentUser={currentUser}

                            onDownloadFile={onDownloadFile}

                        />

                    ))
            }
        </div>
    );
}